"use client";

import { cn } from "@ui/lib";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

/**
 * 给两侧箭头让位的左右留白，加在箭头的 relative 父元素上（缩略图条、标题也加，好和预览对齐）。
 * 按外层 @container 的宽度切：够宽（≥ 43rem）才让出 56px 把箭头放到预览外面；
 * 不够宽就不让位，箭头压在预览左右边上。生图页右栏 1280 宽时只有约 590，
 * 硬让 112px 会把对比图挤成上下排、图小一圈（10/22 实测）。
 */
export const EXAMPLE_ARROW_GUTTER = "@min-[43rem]:px-14";

/** 工作台示例区大预览两侧的上一个 / 下一个（视频页、生图页共用）。
 *  父元素要 relative，外面要有一层 @container，见 EXAMPLE_ARROW_GUTTER。 */
export function ExampleArrow({
	direction,
	label,
	onClick,
}: {
	direction: "prev" | "next";
	label: string;
	onClick: () => void;
}) {
	const Icon = direction === "prev" ? ChevronLeftIcon : ChevronRightIcon;
	return (
		<button
			type="button"
			onClick={onClick}
			aria-label={label}
			className={cn(
				"absolute top-1/2 z-20 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/85 text-zinc-700 shadow-md ring-1 ring-black/5 transition-colors hover:bg-white",
				"@min-[43rem]:h-10 @min-[43rem]:w-10 @min-[43rem]:bg-white @min-[43rem]:hover:bg-zinc-50",
				direction === "prev"
					? "left-2 @min-[43rem]:left-0"
					: "right-2 @min-[43rem]:right-0",
			)}
		>
			<Icon className="h-5 w-5" />
		</button>
	);
}
